import { DragOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

const DataWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;

  background-color: #fff;
`;

const StyledRowWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const FlexibleCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  line-height: 1.3;
`;
const StaticCol = styled.div`
  flex: 0 0 auto;
  min-width: 0;
  display: flex;
  align-items: center;
`;
const ActionCol = styled(StaticCol)`
  margin-left: 8px;
  min-width: 85px;
`;
const DragWrapper = styled.div`
  padding: 4px;

  font-size: 28px;
  line-height: 1;
  color: ${props => props.theme.colorBorder}; // #9b9b9b;
  cursor: grab;
  height: 32px;
  transition: all 0.2s;
  &:hover {
    color: ${props => props.theme.colorPrimary};
  }
`;

export interface IWidgetOptionStructureProps {
  listeners?: any;
  children?: React.ReactNode;
  actions?: React.ReactNode;
}
/**
 * Wrapper per gli stili grafici di configurazione delle opzioni.
 */
export function WidgetOptionStructure(props: IWidgetOptionStructureProps) {
  const { listeners, children, actions } = props;
  return (
    <StyledRowWrapper>
      <StaticCol>
        <DragWrapper {...listeners}>
          <DragOutlined />
        </DragWrapper>
      </StaticCol>
      <FlexibleCol>
        <DataWrapper>{children}</DataWrapper>
        <ActionCol>{actions}</ActionCol>
      </FlexibleCol>
    </StyledRowWrapper>
  );
}
